import { getClassLevel } from './classIdentity.mjs';

export const getSkillTraining = (character = {}, skill) => {
  const sources = [character, character.race, character.background, ...(character.feat || []), ...(character.occupation || [])];
  const expertise = sources.some(source => source?.skills?.[skill]?.expertise === true);
  return { expertise, proficient: expertise || sources.some(source => source?.skills?.[skill]?.proficient === true) };
};

// Keep the physical die intact for dice displays and logs. Only the check's
// arithmetic uses the feature's replacement value.
export const resolveAbilityCheckDie = (naturalD20, { character, rollContext, proficient = false, minimumD20 } = {}) => {
  const isCheck = ['skill-check', 'tool-check', 'ability-check'].includes(rollContext);
  const reliableTalent = isCheck && proficient === true && getClassLevel(character, 'rogue') >= 7 && naturalD20 < 10;
  const effectiveD20 = reliableTalent ? 10 : naturalD20;
  // Glibness replaces a lower roll with a 15.
  if (isCheck && minimumD20 > effectiveD20) return { naturalD20, effectiveD20: minimumD20, reliableTalent, raisedD20: true };
  return { naturalD20, effectiveD20, reliableTalent };
};

export const getProficientTools = (character = {}) => {
  const sources = [...(character.occupation || []), character.race, character.background, ...(character.feat || [])];
  const tools = sources.flatMap(source => [...(Array.isArray(source?.tools) ? source.tools : []),
    ...(Array.isArray(source?.toolProficiencies) ? source.toolProficiencies : [])]);
  if (getClassLevel(character, 'rogue') >= 1) tools.push('Thieves’ Tools');
  const seen = new Set();
  return tools.filter(tool => {
    if (typeof tool !== 'string' || !tool.trim() || /choice/i.test(tool)) return false;
    const key = tool.toLowerCase().replace(/[^a-z]/g, '');
    if (seen.has(key)) return false;
    seen.add(key); return true;
  });
};

// The catalog boolean and custom-armor text flag describe Dexterity (Stealth)
// disadvantage, never a numeric skill modifier. Equipment selection stays with
// the existing caller; numeric legacy checkPenalty values require explicit migration.
export const armorStealthSources = (equippedItems = [], abilityKey, skillKey) => {
  if (abilityKey !== 'dex' || skillKey !== 'stealth') return [];
  const penalized = equippedItems.some(item => {
    const flag = Array.isArray(item) ? item[3] : item?.stealth;
    return flag === true || (typeof flag === 'string' && ['true', 'disadvantage'].includes(flag.trim().toLowerCase()));
  });
  return penalized ? ['Armor (Stealth)'] : [];
};
